const StripeIcon = ({ className = '' }) => {
  return (
    <svg viewBox="0 0 16 16" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0H3ZM8.20661 5.69846C7.67244 5.69846 7.34992 5.84352 7.34992 6.22066C7.34992 6.63244 7.90498 6.81358 8.5936 7.0383C9.7162 7.40465 11.1938 7.88683 11.2 9.67297C11.2 11.404 9.75874 12.4 7.66236 12.4C6.79559 12.4 5.84819 12.2356 4.91087 11.8488V9.54725C5.75748 9.99209 6.82583 10.3209 7.66236 10.3209C8.22677 10.3209 8.62992 10.1758 8.62992 9.73099C8.62992 9.27487 8.02822 9.06638 7.30181 8.81468C6.19553 8.43136 4.8 7.94781 4.8 6.3367C4.8 4.62505 6.16063 3.6 8.20661 3.6C9.04315 3.6 9.86961 3.72571 10.7061 4.04484V6.31736C9.94016 5.92088 8.9726 5.69846 8.20661 5.69846Z"
        fill="#635BFF"
      />
    </svg>
  )
}

export default StripeIcon
